import { Heading, Stack } from '@chakra-ui/react'
import { Product } from 'BrokerTsLib/src/enums'
import { PageContent } from '../../PageContent'
import { ProductDiscountsOverview } from './ProductDiscountsOverview'

export const DiscountsOverview = () => {
  return <PageContent>
    <Heading>Přehled slev</Heading>

    <Stack>
      <ProductDiscountsOverview product={Product.PropertyInsurance} name="Pojištění majetku a odpovědnosti" />
      <ProductDiscountsOverview product={Product.LiabilityInsurance} name="Pojištění samostatné odpovědnosti" />
      <ProductDiscountsOverview product={Product.VehicleInsurance} name="Pojištění motorových vozidel" />
      <ProductDiscountsOverview product={Product.TravelInsurance} name="Cestovní pojištění" />
    </Stack>
  </PageContent>
}
